/**
 * Analytics & Security Integration
 * Tracks user journey, heartbeat, and bandwidth.
 */

const API_BASE_URL = '/api';
let heartbeatInterval;
let consecutiveFailures = 0;
const MAX_CONSECUTIVE_FAILURES = 3;

const Analytics = {
    init: () => {
        // 1. Log Initial Page Load (Visitor Journey)
        Analytics.logEvent('page_load', {
            url: window.location.href,
            referrer: document.referrer
        });

        // 2. Start Heartbeat (every 30 seconds)
        Analytics.startHeartbeat();

        // 3. Track History/Navigation (for SPA)
        Analytics.trackHistory();
    },

    logEvent: async (type, data = {}) => {
        // Circuit Breaker: Stop sending after repeated failures
        if (consecutiveFailures >= MAX_CONSECUTIVE_FAILURES) return;

        try {
            const payload = {
                type,
                timestamp: new Date().toISOString(),
                ...data
            };

            if (window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1') {
                // Skip server logging in development to avoid 405 errors and clutter
                return;
            }

            const resp = await fetch(`${API_BASE_URL}/log`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(payload),
                keepalive: true // Ensure request is sent even if page unloads
            });

            if (resp.ok) {
                consecutiveFailures = 0; // Reset on success
            } else {
                consecutiveFailures++;
            }
        } catch (error) {
            consecutiveFailures++;
        }
    },

    startHeartbeat: () => {
        if (heartbeatInterval) clearInterval(heartbeatInterval);

        heartbeatInterval = setInterval(() => {
            Analytics.logEvent('heartbeat', {
                active: !document.hidden,
                uptime: performance.now() // Session duration in ms
            });
        }, 30000); // 30 seconds
    },

    trackHistory: () => {
        // Track history.pushState calls (SPA navigation)
        const originalPushState = history.pushState;
        history.pushState = function () {
            originalPushState.apply(this, arguments);
            Analytics.logEvent('navigation', { url: window.location.href });
        };

        // Track popstate (back/forward buttons)
        window.addEventListener('popstate', () => {
            Analytics.logEvent('navigation', { url: window.location.href });
        });
    }
};

export default Analytics;

